<template>
  <div class="row py-4">
    <div class="col-12 col-md-8 border-right">
      <div
        v-if="!data.alertable_id"
        class="form-group"
      >
        <label>Content</label>
        <autocomplete
          ref="first"
          :initial-value="data.alertable_id"
          :initial-display="selectedArticle ? selectedArticle.title : null"
          :class="{ 'is-invalid': ((error && error.errors.article_id) ? error.errors.article_id : []).length > 0 }"
          :input-class="['form-control', { 'is-invalid': ((error && error.errors.article_id) ? error.errors.article_id : []).length > 0 }]"
          class="align-self-center"
          placeholder="Select an article..."
          source="/articles?search="
          results-property="data"
          results-display="title"
          @selected="setArticle"
          @clear="setArticle"
        />
      </div>
      <div
        v-else
        class="form-group"
      >
        <label>Content</label>
        <div>
          <span
            v-if="data.alertable_type === 'App\\Models\\Article'"
          >
            <icon icon="articles" />
            <router-link
              :to="{
                name: 'articles.view',
                params: {
                  articleId: data.alertable_id
                }
              }"
            >
              {{ data.alertable.title }}
            </router-link>
          </span>
          <span
            v-else-if="data.alertable_type === 'App\\Models\\Newsletter'"
          >
            <icon icon="newsletters" />
            <router-link
              :to="{
                name: 'newsletters.view',
                params: {
                  newsletterId: data.alertable_id
                }
              }"
            >
              {{ data.subject }}
            </router-link>
          </span>
        </div>
      </div>

      <form-control
        v-model="data.subject"
        :errors="error ? error.errors.subject : []"
        title="Subject"
      />

      <form-control
        v-model="data.preheader_text"
        :errors="error ? error.errors.preheader_text : []"
        title="Pre-header text"
      />

      <div
        v-if="data.alertable_type === 'App\\Models\\Newsletter'"
        class="form-group"
      >
        <label>Alert Lists</label>
        <multiselect
          v-model="data.alert_lists"
          :options="alertLists"
          :allow-empty="true"
          :searchable="true"
          :multiple="true"
          :show-labels="false"
          placeholder="Select Alert Lists"
          class="multiselect"
          style="cursor:pointer"
          select-label="Select"
          label="name"
          track-by="id"
        />
      </div>

      <div
        v-if="data.alertable_type === 'App\\Models\\Newsletter'"
        class="form-group"
      >
        <label>Alert Individual Users</label>
        <multiselect
          v-model="data.users"
          :options="users"
          :internal-search="false"
          :allow-empty="true"
          :searchable="true"
          :multiple="true"
          :show-labels="false"
          class="multiselect"
          style="cursor:pointer"
          select-label="Select"
          label="name"
          track-by="id"
          @search-change="delayGetUsers"
        >
          <span
            slot="option"
            slot-scope="prop"
          >
            {{ prop.option.name }} ({{ prop.option.email }})
          </span>
          <span
            slot="placeholder"
            class="multiselect__placeholder"
          >
            Select users
          </span>
        </multiselect>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>
          Send on
        </label>
        <div class="d-flex">
          <flat-pickr
            class="has-suffix"
            v-model="sendAt"
            :config="{enableTime: true}"
            placeholder="Select date and time"
          />
          <div class="input-suffix">
            <icon icon="date" />
          </div>
        </div>

        <form-control-error
          :errors="(error && error.errors.send_at) ? error.errors.send_at : []"
        />
      </div>


      <form-control
        v-model="data.from_name"
        :errors="error ? error.errors.from_name : []"
        title="From Name"
      />

      <form-control
        v-model="data.from_email"
        :errors="error ? error.errors.from_email : []"
        type="email"
        title="From Email"
      />
    </div>
  </div>
</template>

<script>
import {debounce} from '@/helpers'
import moment from 'moment'
import {search} from '@/helpers'
import Autocomplete from '@/components/Autocomplete'

const defaultData = {
  preheader_text: null,
  from_name: null,
  from_email: null,
  send_at: null,
  article_id: null,
  users: [],
  alert_lists: [],
}

export default {
  components: {
    Autocomplete,
  },
  props: {
    value: {
      required: false,
      type: Object,
      default () {
        return Object.assign({}, defaultData)
      },
    },

    alertable: {
      required: false,
      type: Object,
      default: null,
    },
  },

  data () {
    return {
      data: {},
      error: null,
      sendAt: null,
      loading: false,
      selectedArticle: null,
      sendAtTime: null,
      alertLists: [],
      users: [],
    }
  },

  computed: {
    yesterday () {
      return moment().subtract(1, 'day').toDate()
    },
  },

  watch: {

    value: {
      deep: true,
      handler () {
        this.data = this.value
        if (this.data.send_at && this.data.send_at.indexOf('T') === -1) {
          const m = moment(this.data.send_at.replace(' ', 'T') + 'Z')
          this.sendAt = m.toDate()
          this.sendAtTime = {
            HH: m.format('HH'),
            mm: m.format('mm'),
          }
        }
      },
    },
    data: {
      deep: true,
      handler () {
        this.$emit('input', this.data)
      },
    },
    sendAt () {
      if (this.sendAt) {
        this.data.send_at = moment(this.sendAt).format()
      }
    },

    sendAtTime () {
      if (this.sendAtTime && this.sendAt) {
        // this.data.send_at = moment(this.sendAt).format()
        const m = moment(this.sendAt)
        m.minutes(this.sendAtTime.mm)
        m.hour(this.sendAtTime.HH)

        this.sendAt = m.format()
      }
    },
  },

  beforeMount () {
    if (this.value !== null) {
      this.data = this.value
    }

    if (this.data.send_at) {
      const m = moment(this.data.send_at.replace(' ', 'T') + 'Z')
      this.sendAt = m.toDate()
      this.sendAtTime = {
        HH: m.format('HH'),
        mm: m.format('mm'),
      }
    }

    this.getAlertLists()
  },

  methods: {
    delayGetUsers: debounce(function (query) {
      search('users', query).then((response) => {
        this.users = response.data
      })
    }, 200),

    execute () {
      return this.data.id
        ? this.$http.put(`/alerts/${this.data.id}`, this.data)
        : this.$http.post('/alerts', this.data)
    },
    save () {
      if (!this.loading) {
        this.loading = true
        this.execute()
            .then((response) => {
              this.loading = false
              this.$emit('save-success', response)
            })
            .catch((error) => {
              this.loading = false
              if (error.response && error.response.data && error.response.data.errors) {
                this.error = error.response.data
              }
              this.$emit('save-fail', error)
            })
      }
    },

    sendNow () {
      this.data.send_now = 1
      this.data.send_at = moment().add(2, 'minute')
      this.save()
    },

    getAlertLists () {
      this.$http.get('/alert-lists')
          .then((response) => {
            this.alertLists = response.data.data
          })
    },

    setArticle (article) {
      this.selectedArticle = article
    },

  },
}
</script>
